import React, { useState } from "react";
import { Modal, Typography, Button, Checkbox, Card } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { BusinessState } from "redux-context/business";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

interface CancelSubscriptionModalProps {
  visible: boolean;

  onCancel: () => void;
  onConfirm: (cancelInfluencerBookings: boolean) => void;
}

const CancelSubscriptionModal: React.FC<CancelSubscriptionModalProps> = ({
  visible,

  onCancel,
  onConfirm,
}) => {
  const [cancelInfluencerBookings, setCancelInfluencerBookings] =
    useState(true);

  const { subscription } = useSelector(
    (state: BusinessState) => state.business
  );

  const nextPaymentDate = subscription?.stripeDetails?.nextPaymentDetails
    ? dayjs
        .utc(subscription?.stripeDetails?.nextPaymentDetails?.date)
        .format("MMM DD, YYYY")
    : "";

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      centered
      width={500}
    >
      <div style={{ textAlign: "center" }}>
        <div style={{ marginBottom: 16 }}>
          <span
            style={{
              display: "inline-block",
              background: "#FFE3E3",
              borderRadius: "50%",
              width: 48,
              height: 48,
              lineHeight: "48px",
              fontSize: 28,
              color: "#FF4D6D",
            }}
          >
            <FontAwesomeIcon icon={faTriangleExclamation} color="#FF4D6D" />
          </span>
        </div>
        <Typography.Title level={3} style={{ fontSize: 20, fontWeight: 600 }}>
          Cancel Subscription
        </Typography.Title>
        <Typography.Paragraph
          style={{
            color: "#666",
            fontSize: 16,
            fontWeight: 400,
          }}
        >
          Are you sure you want to cancel your subscription? You'll lose access
          to the Mustard Platform at the end of your billing cycle.
        </Typography.Paragraph>
        <Card
          style={{ marginBottom: 16, background: "#FAFAFA" }}
          bordered={false}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>Current Plan</div>
            <div style={{ fontWeight: 600 }}>{subscription?.planName}</div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 8,
            }}
          >
            <div>Access Until</div>
            <div style={{ fontWeight: 600 }}>{nextPaymentDate}</div>
          </div>
        </Card>
        <Card
          style={{
            marginBottom: 16,
            background: "#fdf9f3",
            border: "1px solid #E5E7EB",
            textAlign: "left",
          }}
          bordered={false}
        >
          <Checkbox
            checked={cancelInfluencerBookings}
            onChange={(e) => setCancelInfluencerBookings(e.target.checked)}
            style={{ marginBottom: 8 }}
          >
            Cancel all upcoming influencer bookings
          </Checkbox>
          <Typography.Paragraph
            style={{ marginBottom: 0, fontSize: 14, color: "#666" }}
          >
            This will automatically cancel any pending or scheduled
            collaborations with creators
          </Typography.Paragraph>
          <a
            href="https://www.mustard.love/terms-of-service#terms-of-payment"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#666", textDecoration: "underline" }}
          >
            Refund And Cancellation Policy
          </a>
        </Card>
        <Button
          type="primary"
          danger
          block
          style={{ marginBottom: 12 }}
          onClick={() => onConfirm(cancelInfluencerBookings)}
        >
          Yes, Cancel Subscription
        </Button>
        <Button block onClick={onCancel}>
          Keep Subscription
        </Button>
      </div>
    </Modal>
  );
};

export default CancelSubscriptionModal;
